/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const topUtmSourceSchema = z.object({
  source: z.string(),
  userCount: z.number(),
});

const topUtmCampaignSchema = z.object({
  campaign: z.string(),
  userCount: z.number(),
});

const sourceKindRowSchema = z.object({
  sourceKind: z.string(),
  count: z.number(),
});

const dailyAttributionSchema = z.object({
  date: z.string(),
  count: z.number(),
});

const dailyInstallByKindSchema = z.object({
  date: z.string(),
  sourceKind: z.string(),
  count: z.number(),
});

const recentUserSchema = z.object({
  userId: z.string(),
  firstCapturedAt: z.number(),
  lastCapturedAt: z.number(),
  touchCount: z.number(),
});

export const attributionOverviewV1DataSchema = z.object({
  period: z.enum(['7d', '30d', 'all']),
  kpis: z.object({
    totalAttributedUsers: z.number(),
    attributedLast7d: z.number(),
    attributedLast30d: z.number(),
    webVisitorTotal: z.number(),
    webVisitorMatched: z.number(),
  }),
  topSources: z.array(topUtmSourceSchema),
  topCampaigns: z.array(topUtmCampaignSchema),
  sourceKindBreakdown: z.array(sourceKindRowSchema),
  dailyAttributions: z.array(dailyAttributionSchema),
  dailyInstalls: z.array(dailyInstallByKindSchema),
  recentUsers: z.array(recentUserSchema),
});

export type IAttributionOverviewV1Data = z.infer<typeof attributionOverviewV1DataSchema>;
export type IAttributionTopSourceRow = z.infer<typeof topUtmSourceSchema>;
export type IAttributionTopCampaignRow = z.infer<typeof topUtmCampaignSchema>;
export type IAttributionSourceKindRow = z.infer<typeof sourceKindRowSchema>;
export type IAttributionDailyRow = z.infer<typeof dailyAttributionSchema>;
export type IAttributionDailyInstallRow = z.infer<typeof dailyInstallByKindSchema>;
export type IAttributionRecentUserRow = z.infer<typeof recentUserSchema>;

export const getAttributionOverviewV1ResponseSchema = createApiResponseSchema(
  attributionOverviewV1DataSchema,
) as z.ZodSchema<IAPI<IAttributionOverviewV1Data>>;

export type IGetAttributionOverviewV1Response = IAPI<IAttributionOverviewV1Data>;
